import { render, staticRenderFns } from "./ContextLabelsSelection.vue?vue&type=template&id=3e74209e&"
import script from "./ContextLabelsSelection.vue?vue&type=script&lang=ts&"
export * from "./ContextLabelsSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports